export const calculateTalentNetPay = ({
  amount,
  skillGigPercentage,
  payrollCostPercentage,
}) => {
  const skillGiggFee = amount * (skillGigPercentage / 100);
  const grossPay = amount - skillGiggFee;
  const payrollCost = grossPay * (payrollCostPercentage / 100);
  const netGrossPay = grossPay - payrollCost;

  return { skillGiggFee, grossPay, payrollCost, netGrossPay };
};

export const payRollCostForCorpToCorp = 5;
export const CORP_TO_CORP_HC = 10;
export const payRollCostForW2 = 18;
export const W2_HC = 12;

export const getTaxCost = (rateType, taxTerm, professionCode) => {
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const SG_PTM = "SG-PTM";
  switch (professionCode) {
    case "HC":
      if (rateType == "Week" && userProfile?.PvtEmpName == SG_PTM) {
        if (taxTerm === "W-2") {
          return W2_HC;
        } else {
          return CORP_TO_CORP_HC;
        }
      } else {
        if (taxTerm === "W-2") {
          return payRollCostForW2;
        } else {
          return payRollCostForCorpToCorp;
        }
      }
    default:
      if (taxTerm === "W-2") {
        return payRollCostForW2;
      } else {
        return payRollCostForCorpToCorp;
      }
  }
};
